var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgEVentilationDamperRoomManual = function SvgEVentilationDamperRoomManual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 132,
    width: 22,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,133v26h-20v-26h20M271,132h-22v28h22v-28h0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 242.96,
    y: 145.5,
    width: 34.08,
    height: 1,
    transform: "translate(-14.76 261.86) rotate(-52.18)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 146,
    r: 2
  })))));
};
export default SvgEVentilationDamperRoomManual;